export type Simulation = {
  uuid: string;
  name: string;
  customers_count: number;
  users_count: number;
  risky_users: number;
  status: "planned" | "active" | "completed";
  start_date: string;
  end_date: string;
  created_at: string;
};

// TODO: Remove below type from here after updating:
// https://gitlab.com/cybersentriq/titanhq/dev/pt/pui-phishtitan/-/blob/main/src/modules/Dashboard/components/LuresChart/index.vue#L52
export type LuresSentVsClicked = {
  date: string;
  sent: number;
  clicked: number;
};

export enum CustomerStatus {
  protected = "protected",
  unprotected = "unprotected",
  unlicensed = "unlicensed",
}

export type Customer = {
  uuid: string;
  name: string;
  campaign: string | null;
  campaign_uuid?: string;
  total_users: number;
  recent_users: number | null;
  lures_clicked: number | null;
  status: keyof typeof CustomerStatus;
  start_date: string | null;
};

export enum CampaignStatus {
  planned = "planned",
  active = "active",
  completed = "completed",
  deleted = "deleted",
}

type ID = {
  uuid: string;
};

export type Campaign = {
  uuid: string;
  organisation_uuid?: string;
  global_organisation_uuid: string;
  name: string;
  simulation_duration: number;
  simulations_count: number;
  customers_users: string;
  customers_count: number;
  users_count: number;
  high_risk_users: number;
  status: keyof typeof CampaignStatus;
  start_date: string;
  end_date?: string;
  created_at: string;
  send_customer_statistics: boolean;
  auto_enrollment: boolean;
  selected_courses?: Array<ID>;
  all_users?: boolean;
  users?: string[];
  all_groups?: boolean;
  groups?: string[];
};

export type User = {
  uuid: string;
  name: string;
  email: string;
  lures_sent: number;
  lures_clicked: number;
  response_rate: number;
};
